import { GroupsOutlined } from '@mui/icons-material';
import { List, ListItemIcon, ListItemText } from '@mui/material';
import { NavDrawerProps, NavSubListItem } from '@procureai/ui-mui';
import { Trans } from 'react-i18next';
import { Link, useMatch } from 'react-router-dom';

import { NavId } from '~/common/types';
import { NavDrawerSimple } from '~/components/NavDrawerSimple/NavDrawerSimple';
import { RouteId } from '~/routes/RouteId';

export const TeamManagementDrawer = (props: NavDrawerProps) => {
  return (
    <NavDrawerSimple navId={NavId.teamManagement} {...props}>
      <List disablePadding sx={{ marginBottom: 4 }}>
        <NavSubListItem
          component={Link}
          to={RouteId.teamManagement}
          selected={!!useMatch({ path: RouteId.teamManagement, end: true })}
        >
          <ListItemIcon>
            <GroupsOutlined />
          </ListItemIcon>
          <ListItemText primary={<Trans i18nKey={`Nav.${NavId.teamManagement}`} />} />
        </NavSubListItem>
      </List>
    </NavDrawerSimple>
  );
};
